﻿
var mmsystem = mmsystem || {};
mmsystem.ui = mmsystem.ui || {};

//Node imports
//mmsystem.core = require('mmsystem-core');
mmsystem.plugins = require('mmsystem-plugins');
mmsystem.ui.ajax = require('mmsystem-ui-ajax');
var events = require('events');
var jQueryValidation = require('jquery-validation');
//var $ = jQuery = mmsystem.core.$;

mmsystem.ui.content = {
    EventEmitter: new events.EventEmitter(),
    Urls: {
        SubmitEnqiure: "/Page/SubmitContact"
    },

    Init: function () {
        this.BasketBox.init();
        this.CookiesPopup.init();
        this.Header.init();
        this.Pages.init();
        this.ReusableComponents.init();
        this.UserLogin.Init();
        this.OrderHistoryItem.Init();
        this.OrderCompleted.Init();
        this.CookiePopup.Init();
        this.ErrorPages.Init();

        this.AddPluginsEventListeners();
    },

    AddPluginsEventListeners: function () {
        mmsystem.plugins.Basket.EventEmitter.on('getProductListHtmlComplete', function (param) {
            console.log('mmsystem.plugins.Basket.EventEmitter: getProductListHtmlComplete');
            //recreate Products functionality
            mmsystem.ui.content.ReusableComponents.ProductItemHover();

        });
    },

    BasketBox: {
        init: function () {
            this.toggle();
        },

        toggle: function () {
            $('.toggle-basket-btn').click(function () {
                if ($('#basketBox').hasClass('active')) {
                    mmsystem.ui.content.Pages.Shipping.closePopup();
                    mmsystem.ui.content.BasketBox.close();
                } else {
                    mmsystem.ui.content.BasketBox.open();
                }
            });
        },

        open: function () {
            $('#basketBox').addClass('active');
            $('.toggle-basket-btn span').text('Close');
        },

        close: function () {
            $('#basketBox').removeClass('active');
            $('.toggle-basket-btn span').text('Open');
        }
    },

    CookiesPopup: {
        init: function () {
            if (sessionStorage.getItem('pops') !== 'visible') {
                setTimeout(function () {
                    $('#cookiesPopup').addClass('active');
                }, 1000);
            }

            this.close();
        },

        close: function () {
            $('#cookiesPopupBtn').click(function () {
                $('#cookiesPopup').removeClass('active');
                sessionStorage.setItem('pops', 'visible');
            });
        }
    },

    Header: {
        init: function () {
            this.desktopMenuPanel.init();
            this.Sidenav.init();
        },

        desktopMenuPanel: {
            init: function () {
                this.onHeaderMenuClick();
                this.handleOuterClickOnPanelActive();
            },

            onHeaderMenuClick: function () {
                $('#headerMenu .tab').click(function () {
                    var el = $(this),
                        tgt = el.attr('data-content'),
                        list = $('.tab__body', this).html(),
                        panel = $('#headerDesktopPanel'),
                        panelMenu = $('#headerDesktopPanel .sub-menu');

                    tgt === panel.attr('data-content') && panel.hasClass('active') ?
                        mmsystem.ui.content.Header.desktopMenuPanel.close(el, panel) :
                        mmsystem.ui.content.Header.desktopMenuPanel.open(list, tgt, panel, panelMenu);
                });
            },

            handleOuterClickOnPanelActive: function () {
                $(document).click(function (e) {
                    var panel = $('#headerDesktopPanel'),
                        el = $('#headerMenu .tab.active');

                    if (panel.hasClass('active')) {
                        if ($(e.target).closest(panel).length === 0 && $(e.target).closest('#header').length === 0)
                            mmsystem.ui.content.Header.desktopMenuPanel.close(el, panel);
                    }
                });
            },

            close: function (el, panel) {
                el.removeClass('active');
                panel.removeClass('active');
            },

            open: function (list, tgt, panel, panelMenu) {
                panelMenu.html(list);
                panel.addClass('active');
                panel.attr('data-content', tgt);
            }
        },

        Sidenav: {
            init: function () {
                this.handleWindowResize();
                this.toggleSidenav();
            },

            handleWindowResize: function () {
                $(window).resize(function () {
                    mmsystem.ui.content.Header.Sidenav.close();
                });
            },

            toggleSidenav: function () {
                $('#burgerMenu, #screenOverlayDark').click(function () {
                    $('#header').hasClass('active') ?
                        mmsystem.ui.content.Header.Sidenav.close() :
                        mmsystem.ui.content.Header.Sidenav.open();
                });
            },

            close: function () {
                $('html').removeClass('no-scroll');
                $('#header').removeClass('active');
            },

            open: function () {
                $('html').addClass('no-scroll');
                $('#header').addClass('active');
            }
        }
    },

    Pages: {
        init: function () {
            //console.log('mmsystem.ui.content.Pages.init ...');
            this.Account.init();
            this.Basket.init();
            this.Checkout.init();
            this.Contact.init();
            this.Home.init();
            this.Packages.init();
            this.Product.init();
            this.Products.init();
            this.Shipping.init();
            this.TheScience.init();
        },

        Account: {
            init: function () {
                this.orderBtnTextToggle();
            },

            orderBtnTextToggle: function () {
                $('.order .tab__header').click(function () {
                    $(this).closest('.tab').hasClass('active') ?
                        $('.order__toggle-btn', this).html('<span>SEE&nbsp;</span>DETAILS') :
                        $('.order__toggle-btn', this).html('LESS<span>&nbsp;DETAILS</span>');
                });
            }
        },

        Basket: {
            init: function () {
                this.toggleDiscountInput();
            },

            toggleDiscountInput: function () {
                $('.promo-code__btn').click(function () {
                    var code = $('.promo-code__val');

                    code.toggleClass('active');
                    if (code.hasClass('active')) {
                        $(this).text('Cancel x');
                    } else {
                        $(this).text('Add Promo Code +');
                        code.val('').removeClass('error');
                    }
                });
            }
        },

        Checkout: {
            init: function () {
                this.closeBillingAddress();
                this.openBillingAddress();
                this.toggleOrderReviewInputState();
            },

            closeBillingAddress: function () {
                $('#shipBillSame').click(function () {
                    $('.billing-address').removeClass('active');
                    $('.billing-address').removeClass('overflow-visible');
                });
            },

            openBillingAddress: function () {
                $('#shipBillDiff').click(function () {
                    $('.billing-address').addClass('active');
                    setTimeout(function () {
                        $('.billing-address').addClass('overflow-visible');
                    }, 200);
                });
            },

            toggleOrderReviewInputState: function () {
                $('.order-row__update-btn').click(function () {
                    var row = $(this).closest('.order-row');
                    var flds = row.find('input');

                    if (row.hasClass('active')) {
                        row.removeClass('active');
                        flds.attr('readonly', true);
                        row.find('.order-row__update-btn').text('Edit');
                    } else {
                        row.addClass('active');
                        flds.attr('readonly', false);
                        row.find('.order-row__update-btn').text('Save');
                    }
                });
            }
        },

        Contact: {
            init: function () {
                //console.log('mmsystem.ui.content.Pages.Contact.init ...');
                //If Form exist
                console.log(mmsystem.ui.content.Pages.Contact.DomElements.Form.GetContactForm().length > 0);
                if (mmsystem.ui.content.Pages.Contact.DomElements.Form.GetContactForm().length > 0) {
                    this.AddEventListers();
                    mmsystem.ui.content.Validation.Init(mmsystem.ui.content.Pages.Contact.DomElements.Form.GetContactForm(), mmsystem.ui.content.Validation.Rules.ContactFormRules);
                }

            },

            AddEventListers: function () {
                console.log('AddEventListers ...');
                //Submit Enquire
                mmsystem.ui.content.Pages.Contact.DomElements.SubmitEnquireButton().click(function (e) {
                    e.preventDefault();
                    if (mmsystem.ui.content.Validation.Form.valid()) {
                        //console.log('send enquire');
                        var data = mmsystem.ui.content.Pages.Contact.DomElements.Form.GetContactData();
                        //console.log(data);
                        mmsystem.ui.ajax.SubmitEnquire(mmsystem.ui.content.Urls.SubmitEnqiure, data);
                        mmsystem.plugins.AjaxCover.ShowOnButton($(this).attr('id'));
                    }
                });

                mmsystem.ui.ajax.EventEmitter.on('submitEnquireComplete', function (param) {
                    console.log('mmsystem.ui.ajax.EventEmitter: submitEnquireComplete');
                    var result = param.responseJSON;
                    if (result && result.Type == 1) {
                        mmsystem.ui.content.Pages.Contact.DomElements.SubmitEnquireButton().attr("disabled", "disabled");
                        $('.equire-response-message').removeClass('d-none').addClass('text-success').text('success');
                        mmsystem.ui.content.Pages.Contact.DomElements.Form.GetContactForm().hide();
                    }

                    if (result && result.Message)
                        $('.equire-response-message').text(result.Message);

                    mmsystem.plugins.AjaxCover.Hide();

                });

                //Server Error
                mmsystem.ui.ajax.EventEmitter.on("serverError", function (e, param) {
                    console.log('Server Error');
                    mmsystem.plugins.AjaxCover.Hide();
                    $('.equire-response-message').removeClass('d-none').addClass('text-danger').text('sending failed, please try again');
                });
            },

            DomElements: {
                SubmitEnquireButton: function () {
                    return $('#send-enquiry');
                },

                Form: {
                    GetById: function (id) {
                        return $('form#' + id);
                    },

                    GetContactForm: function () {
                        return this.GetById('form-contact');
                    },

                    GetContactFormElement: function () {
                        return $('.contact__form');
                    },

                    ContactTypeId: function () {
                        return $('#contact-type-id');
                    },
                    Email: function () {
                        return $('#contacFormEmail');
                    },
                    Name: function () {
                        return $('#contacFormName');
                    },
                    PhoneNumber: function () {
                        return $('#contacFormPhone');
                    },
                    Message: function () {
                        return $('#contacFormMessage');
                    },

                    GetContactData: function () {
                        var data = {
                            ContactTypeId: mmsystem.ui.content.Pages.Contact.DomElements.Form.ContactTypeId().val(),
                            Name: mmsystem.ui.content.Pages.Contact.DomElements.Form.Name().val(),
                            Email: mmsystem.ui.content.Pages.Contact.DomElements.Form.Email().val(),
                            PhoneNumber: mmsystem.ui.content.Pages.Contact.DomElements.Form.PhoneNumber().val(),
                            Message: mmsystem.ui.content.Pages.Contact.DomElements.Form.Message().val()
                        }

                        return data;
                    }
                }
            }
        },

        Home: {
            init: function () {
                this.Hero.init();
                this.Custom.init();
                this.onLoad();
                this.Packages.init();
            },

            Hero: {
                init: function () {
                    this.handleHeroSlider();
                    this.onMouseOverSliderBtn();
                },

                handleHeroSlider: function () {
                    $('#homeHero button').click(function () {
                        var btn = $(this),
                            slide = parseInt($('#homeHero').attr('data-slide'));

                        if (btn.hasClass('next')) {
                            if (slide < 3)
                                slide++;
                            else
                                slide = 1;
                        } else {
                            if (slide > 1)
                                slide--;
                            else
                                slide = 3;
                        }

                        mmsystem.ui.content.Pages.Home.Hero.updateSlide(slide);
                    });
                },

                onMouseOverSliderBtn: function () {
                    $('#homeHero button').mouseover(function () {
                        $(this).hasClass('prev') ? $(this).addClass('lg') : $('#homeHero button.prev').addClass('sm');
                    });
                    $('#homeHero button').mouseout(function () {
                        $('#homeHero button').removeClass('lg sm');
                    });
                },

                updateSlide: function (slide) {
                    var hero = $('#homeHero');
                    
                    const titles = this.getSlideContent(hero.find('h1'));
                    const subtitles = this.getSlideContent(hero.find('p'));
                    const dirs = this.getSlideHref(hero.find('a:nth-of-type(1)'));
                    const dirs2 = this.getSlideHref(hero.find('a:nth-of-type(2)'));
                    
                    hero.attr('data-slide', slide);
                    hero.css({
                        'background': '#fff url("../../images/pages/home/hero-' + slide + '.jpg") center bottom no-repeat',
                        'background-size': 'cover'
                    });
                    hero.find('h1').html(titles[slide - 1]);
                    hero.find('p').html(subtitles[slide - 1]);
                    hero.find('a:nth-of-type(1)').attr('href', dirs[slide - 1]);
                    hero.find('a:nth-of-type(2)').attr('href', dirs2[slide - 1]);
                },

                getSlideContent: function (element) {
                    return element.data('hero-content');
                },

                getSlideHref: function (element) {
                    return element.data('hero-href');
                }
            },

            Custom: {
                init: function () {
                    this.handleExampleSwap();
                },

                handleExampleSwap: function () {
                    $('.home__custom__example button').click(function () {
                        var btn = $(this),
                            list = $('.home__custom__example');
                        var el = list.filter('.active');
                        var num = parseInt(el.attr('data-custom')) - 1;

                        if (btn.hasClass('next')) {
                            if (num > 2)
                                num = 0;
                            else
                                num++;
                        } else {
                            if (num === 0)
                                num = 3;
                            else
                                num--;
                        }

                        el.removeClass('active');
                        $(list[num]).addClass('active');
                    });
                }
            },

            onLoad: function () {
                $(document).ready(function () {
                    if (window.location.pathname === '/') {
                        var slideHero = parseInt($('#homeHero').attr('data-slide')),
                            firstPkg = $('#homePackages .package--home')[0];

                        mmsystem.ui.content.Pages.Home.Hero.updateSlide(slideHero);
                        $(firstPkg).addClass('active');
                    }
                });
            },

            Packages: {
                init: function () {
                    this.packagesSlider();
                },

                packagesSlider: function () {
                    $('.home__packages__selection__top button').click(function () {
                        var pkgsList = $('.package--home'),
                            pkgActiveIdx = pkgsList.index(pkgsList.filter('.active'));

                        pkgsList.removeClass('active');

                        if ($(this).hasClass('next')) {
                            pkgsList.length === pkgActiveIdx + 1 ?
                                $(pkgsList[0]).addClass('active') :
                                $(pkgsList[pkgActiveIdx + 1]).addClass('active');
                        } else {
                            pkgActiveIdx === 0 ?
                                $(pkgsList[pkgsList.length - 1]).addClass('active') :
                                $(pkgsList[pkgActiveIdx - 1]).addClass('active');
                        }
                    });
                }
            }
        },

        Packages: {
            init: function () {
                this.animateExpandBtn();
            },

            animateExpandBtn: function () {
                $('.packages__list__expand-btn').mouseenter(function () {
                    var n1 = $('span:nth-of-type(1)', this),
                        n2 = $('span:nth-of-type(2)', this),
                        n3 = $('span:nth-of-type(3)', this);

                    n1.addClass('animate');
                    setTimeout(function () {
                        n1.removeClass('animate');
                        n2.addClass('animate');
                    }, 100);
                    setTimeout(function () {
                        n2.removeClass('animate');
                        n3.addClass('animate');
                    }, 200);
                    setTimeout(function () {
                        n3.removeClass('animate');
                    }, 300);
                });
            }
        },

        Product: {
            init: function () {
                this.handleDefinitionsSwitch();
                this.handleModalCrossClick();
                this.handleModalOuterClick();
                this.handleQtySelection();
                this.handleThumbnailClick();
                this.infoPopupToggle();
                this.modalOpen();
                this.onLoad();
                this.onThumbnailsBtnClick();
                this.onWindowResize();
            },

            activateThumbnailsSlider: function () {
                var thumbsList = $('.product__img__thumbnails ul'),
                    thumbsListPos = parseInt(thumbsList.attr('data-position')),
                    wWidth = $(window).width(),
                    leftVal = parseInt((thumbsList.css('left')).split('px')[0]),
                    val;

                //render positive
                if (leftVal < 0) { leftVal = leftVal * -1; }

                //define value to add/subtract
                if (wWidth < 576) { val = (wWidth - 20); }
                if (wWidth > 575 && wWidth < 768) { val = 520; }
                if (wWidth > 767 && wWidth < 992) { val = 340; }
                if (wWidth > 991 && wWidth < 1200) { val = (440 + (50 / 3)); }
                if (wWidth > 1199) { val = (510 + (70 / 3)); }

                //add/subtract to existing value
                leftVal = (thumbsListPos / 4) * val;

                //assign new left value
                thumbsList.css('left', '-' + leftVal + 'px');
            },

            handleDefinitionsSwitch: function () {
                $('.product__content--switcher button span').click(function () {
                    var btns = $('.product__content--switcher button'),
                        descs = $('.product__content__switchable'),
                        pos = btns.index($(this).closest('button'));

                    btns.removeClass('active');
                    descs.removeClass('active');
                    $(btns[pos]).addClass('active');
                    $(descs[pos]).addClass('active');
                });
            },

            handleModalCrossClick: function () {
                $('.modal__window .cross').click(function () {
                    mmsystem.ui.content.Pages.Product.modalClose();
                });
            },

            handleModalOuterClick: function () {
                $(window).click(function (e) {
                    var tgt = $(e.target);

                    if ($('.modal').hasClass('active') && !tgt.parents('.modal').length && !tgt.hasClass('modal-trigger'))
                        mmsystem.ui.content.Pages.Product.modalClose();
                });
            },

            handleQtySelection: function () {
                $('.capsules-qty').click(function () {
                    mmsystem.ui.content.Pages.Product.infoPopupClose();
                    $(this).siblings('button').removeClass('active');
                    $(this).addClass('active');
                });
            },

            handleThumbnailClick: function () {
                $('.product-page .thumbnail').click(function () {
                    var bg = $(this).css('background-image'),
                        list = $('.product-page .thumbnail');

                    $('.product__img__main').css({
                        'background': 'transparent ' + bg + ' center no-repeat',
                        'background-size': 'contain'
                    });
                    list.css('background-color', 'transparent').removeClass('active');
                    $(this).addClass('active');
                    mmsystem.ui.content.Pages.Product.infoPopupClose();
                });
            },

            infoPopupClose: function () {
                $('.info-popup').removeClass('active');
            },

            infoPopupToggle: function () {
                $('.info-popup__trigger, .info-popup .cross').click(function () {
                    $('.info-popup').toggleClass('active');
                });
            },

            modalClose: function () {
                $('html').removeClass('no-scroll');
                $('.modal').removeClass('active');
            },

            modalOpen: function () {
                $('.modal-trigger').click(function () {
                    var poster = $('#modalPoster'),
                        curr = $('.product__img__main');
                    var currImg = curr.css('background-image'),
                        currCol = curr.css('background-color');

                    $('html').addClass('no-scroll');
                    $('.modal').addClass('active');
                    mmsystem.ui.content.Pages.Product.infoPopupClose();
                    poster.css({
                        'background': currCol + ' ' + currImg + ' center center no-repeat',
                        'background-size': 'contain'
                    });
                });
            },

            onLoad: function () {
                if (window.location.href.indexOf('product') > -1) {
                    $(document).ready(function () {
                        var thumbs = $('.product-page .thumbnail'),
                            next = $('.product__img__thumbnails button.next');

                        thumbs.length > 4 && next.addClass('active');
                    });
                }
            },

            onThumbnailsBtnClick: function () {
                $('.product__img__thumbnails button').click(function () {
                    var thumbs = $('.product__img__thumbnails .thumbnail'),
                        thumbsList = $('.product__img__thumbnails ul'),
                        thumbsListPos = parseInt(thumbsList.attr('data-position')),
                        prev = $('.product__img__thumbnails button.prev'),
                        next = $('.product__img__thumbnails button.next');

                    if ($(this).hasClass('next')) {
                        thumbsListPos += 4;
                        console.log(thumbsListPos);
                        thumbsListPos === 4 && prev.addClass('active');
                        thumbs.length <= (thumbsListPos + 4) && next.removeClass('active');
                    } else {
                        thumbsListPos -= 4;
                        thumbsListPos === 0 && prev.removeClass('active');
                        thumbs.length > thumbsListPos && next.addClass('active');
                    }

                    thumbsList.attr('data-position', thumbsListPos);
                    thumbsList.addClass('left-right--2s');
                    mmsystem.ui.content.Pages.Product.activateThumbnailsSlider(thumbsListPos);
                    setTimeout(function () {
                        thumbsList.removeClass('left-right--2s');
                    }, 200);
                });
            },

            onWindowResize: function () {
                $(window).resize(function () {
                    mmsystem.ui.content.Pages.Product.activateThumbnailsSlider();
                });
            }
        },

        Products: {
            init: function () {
                this.closeMobileFiltersOnResize();
            },

            closeMobileFiltersOnResize: function () {
                $(window).resize(function () {
                    var initWidth = $(window).width();

                    $('.tab__header, .tab__body').addClass('no-transition');
                    setTimeout(function () {
                        var currentWidth = $(window).width();

                        initWidth === currentWidth &&
                            $('.tab__header, .tab__body').removeClass('no-transition');
                    }, 100);
                });
            },
        },

        Shipping: {
            init: function () {
                this.correctSelectErrors();
                this.handleInfoBtnClick();
                this.handlePopupCrossClick();
            },

            closePopup: function () {
                $('#basketBox .tab__body').removeClass('overflow-visible');
                $('.items__shipping__popup').removeClass('active');
            },

            correctSelectErrors: function () {
                $('#complete-section-btn, .select').click(function () {
                    var sels = $('.payment-shipping__address .select');

                    sels.each(function () {
                        if ($('.title > input', this).hasClass('error')) {
                            if (!($('p.error-msg', this).length > 0)) {
                                $(this).css('margin-bottom', '3rem');
                                $('<p class="error-msg">This field is required</p>').appendTo($(this));
                            }
                        } else {
                            if ($('p.error-msg', this).length > 0) {
                                $('p.error-msg', this).remove();
                                $(this).css('margin-bottom', '.5rem');
                            }
                        }
                    });
                });
            },

            handleInfoBtnClick: function () {
                $('.items__shipping__info-btn').click(function () {
                    if (!$('.items__shipping__popup').hasClass('active')) {
                        $('#basketBox').addClass('overflow-visible');
                        $('#basketBox .tab__body').addClass('overflow-visible');
                        $('.items__shipping__popup').addClass('active');
                    } else {
                        mmsystem.ui.content.Pages.Shipping.closePopup();
                    }
                });
            },

            handlePopupCrossClick: function () {
                $('.items__shipping__popup .cross').click(function () {
                    mmsystem.ui.content.Pages.Shipping.closePopup();
                });
            }
        },

        TheScience: {
            init: function () {
                this.handlePostsMenuClick();
                this.handleSliderBtnClick();
                this.onMouseOverSliderBtn();
            },

            handlePostsMenuClick: function () {
                $('#theSciencePosts a').click(function () {
                    $(this).siblings('a').removeClass('active');
                    $(this).addClass('active');
                });
            },

            handleSliderBtnClick: function () {
                $('#theScienceHero button').click(function () {
                    var el = $(this),
                        slides = $('.article-slide'),
                        currSlide = slides.filter('.active'),
                        currSlidePos = slides.index(currSlide),
                        newSlidePos = currSlidePos;

                    currSlide.removeClass('active');

                    if (el.hasClass('next')) {
                        newSlidePos++;
                        if (newSlidePos === slides.length)
                            newSlidePos = 0;
                    } else {
                        newSlidePos--;
                        if (newSlidePos < 0)
                            newSlidePos = slides.length - 1;
                    }

                    $(slides[newSlidePos]).addClass('active');
                    $('#theScienceHero').css({
                        'background': '#fff url(../images/pages/the-science/post-' + (newSlidePos + 1) + '.jpg) center no-repeat',
                        'background-size': 'cover'
                    });
                });
            },

            onMouseOverSliderBtn: function () {
                $('#theScienceHero button').mouseover(function () {
                    $(this).hasClass('prev') ? $(this).addClass('lg') : $('#theScienceHero button.prev').addClass('sm');
                });
                $('#theScienceHero button').mouseout(function () {
                    $('#theScienceHero button').removeClass('lg sm');
                });
            }
        }
    },

    ReusableComponents: {
        init: function () {
            this.Basket.init();
            this.Carousel.init();
            this.DropdownMenu.init();
            this.ProductItemHover();
            this.Select.init();
            this.Tab.init();
        },

        Basket: {
            init: function () {
                this.handleOuterClick();
                this.handleAddToBasket();
                this.toggle();
            },

            handleAddToBasket: function () {
                $('.add-to-cart__btn').click(function () {
                    $('.basket__btn .icon-wrapper').addClass('animate');
                    setTimeout(function () {
                        $('.basket__btn .icon-wrapper').removeClass('animate');
                        mmsystem.ui.content.ReusableComponents.Basket.open();
                    }, 500);
                });
            },

            handleOuterClick: function () {
                $(window).click(function (e) {
                    var tgt = $(e.target);

                    (!tgt.parents('.basket').length) &&
                        mmsystem.ui.content.ReusableComponents.Basket.close();
                });
            },

            toggle: function () {
                $('.basket__btn').click(function () {
                    $('.basket').hasClass('active') ?
                        mmsystem.ui.content.ReusableComponents.Basket.close() :
                        mmsystem.ui.content.ReusableComponents.Basket.open();
                });
            },

            open: function () {
                var el = $('#headerMenu .tab.active'),
                    panel = $('#headerDesktopPanel');

                mmsystem.ui.content.Header.Sidenav.close();
                panel.hasClass('active') && mmsystem.ui.content.Header.desktopMenuPanel.close(el, panel);
                mmsystem.ui.content.ReusableComponents.DropdownMenu.close();
                $('.basket, #screenOverlayLight').addClass('active');
            },

            close: function () {
                $('.basket, #screenOverlayLight').removeClass('active');
            }
        },

        Carousel: {
            init: function () {
                this.onDotClick();
                this.onNextPrevClick();
            },

            onDotClick: function () {
                $('.dot').click(function () {
                    var carousel = $(this).closest('.carousel');
                    var slides = carousel.find('.slide');
                    var dots = carousel.find('.dot');
                    var dot = $(this);
                    var idx = parseInt(dot.attr('data-target'));

                    mmsystem.ui.content.ReusableComponents.Carousel.update(carousel, slides, dots, idx);
                });
            },

            onNextPrevClick: function () {
                $('.carousel .arrow').click(function () {
                    var carousel = $(this).closest('.carousel');
                    var slides = carousel.find('.slide');
                    var dots = carousel.find('.dot');
                    var idx = dots.index(dots.filter('.active'));
                    var icon = $('.icon', this);

                    if (!icon.hasClass('gray')) {
                        if ($(this).hasClass('next'))
                            idx++;
                        else
                            idx--;
                    }

                    mmsystem.ui.content.ReusableComponents.Carousel.update(carousel, slides, dots, idx);
                });
            },

            update: function (carousel, slides, dots, idx) {
                $(slides[idx]).siblings().removeClass('active');
                $(slides[idx]).addClass('active');

                carousel.find('.arrow .icon').removeClass('gray');
                idx + 1 === slides.length && carousel.find('.next .icon').addClass('gray');
                idx === 0 && carousel.find('.prev .icon').addClass('gray');

                $(dots[idx]).siblings().removeClass('active');
                $(dots[idx]).addClass('active');
            }
        },

        DropdownMenu: {
            init: function () {
                this.handleOuterClick();
                this.handleUpdate();
                this.toggle();
            },

            handleOuterClick: function () {
                $(window).click(function (e) {
                    var tgt = $(e.target);

                    !tgt.parents('.dropdown').length &&
                        mmsystem.ui.content.ReusableComponents.DropdownMenu.close();
                });
            },

            handleUpdate: function () {
                $('.dropdown li').click(function () {
                    var el = $(this).closest('.dropdown');

                    el.is('#currencies') &&
                        el.find('.dropdown__value').html($(this).html());

                    if (!el.hasClass('setting')) {
                        $(this).siblings().removeClass('active');
                        $(this).addClass('active');
                        setTimeout(function () {
                            mmsystem.ui.content.ReusableComponents.DropdownMenu.close();
                        }, 200);
                    }
                });
            },

            toggle: function () {
                $('.dropdown__value').click(function () {
                    var el = $(this).closest('.dropdown');

                    if (el.hasClass('active')) {
                        if (el.parents('.mobile-submenu').length) {
                            $(window).width() > 991 ?
                                mmsystem.ui.content.ReusableComponents.DropdownMenu.close() :
                                el.removeClass('active');
                        } else {
                            mmsystem.ui.content.ReusableComponents.DropdownMenu.close();
                        }
                    } else {
                        el.parents('mobile-submenu').length ?
                            el.siblings().removeClass('active') :
                            mmsystem.ui.content.ReusableComponents.DropdownMenu.open(el);
                    }
                });
            },

            open: function (el) {
                (!el.parents('.mobile-submenu').length || $(window).width() > 991) ?
                    mmsystem.ui.content.ReusableComponents.DropdownMenu.close() :
                    el.siblings('.dropdown').removeClass('active');

                //mmsystem.ui.content.Header.Sidenav.close();
                mmsystem.ui.content.ReusableComponents.Basket.close();
                el.addClass('active');
            },

            close: function () {
                $('.dropdown').removeClass('active');
            }
        },

        emailValidation: function (email) {
            var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regex.test(email);
        },

        ProductItemHover: function () {
            $('.product-item').mouseover(function () {
                var hex = $(this).attr('data-hex');

                $(this).css('background-color', hex + '80');
            });

            $('.product-item').mouseout(function () {
                $(this).css('background-color', 'transparent');
            });
        },

        Select: {
            init: function () {
                this.handleOuterClick();
                this.toggle();
            },

            handleOuterClick: function () {
                $(window).click(function (e) {
                    var el = $(e.target);

                    !el.parents('.select').length && 
                        mmsystem.ui.content.ReusableComponents.Select.close();
                });
            },

            toggle: function () {
                $('.select li').click(function (e) {
                    var el = $(this);
                    var slt = el.closest('.select');

                    if (el.hasClass('option')) {
                        var txt = el.text(),
                            dataVal = el.attr('data-value');
                        slt.find('.title').attr('data-value', dataVal);
                        slt.find('.title__text').text(txt);
                        slt.find('.option.selected-option').removeClass('selected-option');
                        el.addClass('selected-option');
                    }

                    slt.hasClass('active') ?
                        mmsystem.ui.content.ReusableComponents.Select.close() :
                        mmsystem.ui.content.ReusableComponents.Select.open(slt);
                });
            },

            open: function (slt) {
                $('.select').removeClass('active');
                slt.addClass('active');
            },

            close: function () {
                $('.select').removeClass('active');
            }
        },

        Tab: {
            init: function () {
                this.toggle();
            },

            toggle: function () {
                $('.tab:not(#basketBox) .tab__header').click(function (e) {
                    var tab = $(this).closest('.tab');

                    tab.hasClass('active') ?
                        mmsystem.ui.content.ReusableComponents.Tab.close(tab):
                        mmsystem.ui.content.ReusableComponents.Tab.open(tab);                    
                });
            },

            open: function (tab) {
                if (!tab.hasClass('sub')) {
                    tab.hasClass('order') ?
                        $('.tab:not(.account__orders)').removeClass('active') :
                        $('.tab').removeClass('active');
                }
                tab.addClass('active');
            }, 

            close: function (tab) {
                tab.hasClass('tab--mobile') ?
                    $('.tab').removeClass('active') :
                    tab.removeClass('active');
            }
        }
    },

    UserLogin: {
        Init: function () {
            this.UserIconToggle();
        },

        UserIconToggle: function () {
            var icons = $('.user-section__options a');

            icons.each(function () {
                if ($(this).hasClass('active')) {
                    var newSrc = $('img', this).attr('src').replace('.svg', '--white.svg');
                    $('img', this).attr('src', newSrc);
                }
            });

            icons.hover(function () {
                if (!$(this).hasClass('active')) {
                    var newSrc = $('img', this).attr('src').replace('.svg', '--white.svg');
                    $('img', this).attr('src', newSrc);
                }
            }, function () {
                if (!$(this).hasClass('active')) {
                    var regSrc = $('img', this).attr('src').replace('--white', '');
                    $('img', this).attr('src', regSrc);
                }
            });
        }

    },

    OrderHistoryItem: {
        Init: function () {
            this.OrderHistoryListToggle();
        },

        OrderHistoryListToggle: function () {
            $('.order-history__row .plus-minus').click(function () {
                $(this).parents('.order-history__row').toggleClass('active');
            });
        }
    },

    OrderCompleted: {
        Init: function () {
            this.OrderCompletedDetailsToggle();
            this.OrderCompletedPrint();
        },

        OrderCompletedDetailsToggle: function () {
            $('.order-completed__row .plus-minus').click(function () {
                $(this).siblings('.tables').toggleClass('active');
            });
        },

        OrderCompletedPrint: function () {
            $('#print-btn').click(function () {
                window.print();
            });
        }
    },

    CookiePopup: {
        Init: function () {
            this.SaveCookiePopupChoice();
        },

        SaveCookiePopupChoice: function () {
            if (localStorage.getItem('pops') !== 'visible') {

                setTimeout(function () {
                    $('.cookie-popup').addClass('active');
                }, 1000);

                $('.cookie-popup .btn').click(function () {
                    $('.cookie-popup').removeClass('active');
                });

                localStorage.setItem('pops', 'visible');
            }
        }
    },

    ErrorPages: {
        Init: function () {
            this.RefreshPage();
        },

        RefreshPage: function () {
            $('.refresh-btn').click(function () {
                location.reload();
            });
        }
    },

    Validation: {
        Form: {},
        Validator: {},

        Init: function (form, rules) {
            this.Form = form;
            this.Validator = form.validate();

            //console.log(this.Validator);
            //console.log(this.Form);

            //Setup rules
            if (rules)
                this.Validator.settings.rules = rules;

            
        },

        ClearRules: function () {
            //console.log(this.Validator);
            this.Validator.settings.rules = {};
        },
        SetRules: function (rules) {
            //console.log(this.Validator);
            this.Validator.settings.rules = rules;
        },
        AppendRules: function (rules) {
            this.Validator.settings.rules.push(rules);
        },
        Rules: {
            EmailRules: {
                email: {
                    required: true,
                    email: true
                }
            },
            PolicyRules: {
                dataAgree: {
                    required: true
                }
            },

            ContactFormRules: {
                contactFormEmail: { required: true, email: true },
                contactFormPhone: { required: true },
                contactFormMessage: { required: true },
                contactFormName: { required: true }
            },

            //GetCheckoutRules: function () { return Object.assign(mmsystem.ui.content.orders.Validation.Rules.EmailRules, mmsystem.ui.content.orders.Validation.Rules.PolicyRules) },
        }
    },

};


//Node exports
module.exports = mmsystem.ui.content;

// Hot Module Accept
if (module.hot) {
    module.hot.accept();
}